(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  function initAccordion() {
    if (window.innerWidth < 750) {
      const headings = document.querySelectorAll('.footer-block__heading');
      
      headings.forEach(heading => {
        // Remove event listeners antigos para evitar duplicatas
        heading.removeEventListener('click', toggleAccordion);
        heading.addEventListener('click', toggleAccordion);
      });
    }
  }

  function toggleAccordion() {
    this.classList.toggle('active');
    const content = this.nextElementSibling;
    content.style.display = this.classList.contains('active') ? 'block' : 'none';
  }

  // Inicializa na carga
  initAccordion();
  
  // Re-inicializa no resize (opcional)
  window.addEventListener('resize', initAccordion);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  
// Toggle dos submenus
document.querySelectorAll('.menu-drawer__menu-item-link').forEach(link => {
  link.addEventListener('click', (e) => {
    const submenu = link.nextElementSibling;
    if (submenu && submenu.classList.contains('menu-drawer__submenu')) {
      e.preventDefault();
      link.classList.toggle('active');
    }
  });
});

// Função para fechar o drawer e limpar todos os estados
const closeDrawer = () => {
  const drawer = document.getElementById('Details-menu-drawer-container');
  const menuDrawer = document.getElementById('menu-drawer');
  const menuIcon = document.querySelector('.header__icon--menu');
  
  if (drawer && menuDrawer && menuIcon) {
    drawer.removeAttribute('open'); // Fecha o <details>
    menuIcon.setAttribute('aria-expanded', 'false'); // Atualiza aria-expanded
    document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop'); // Remove bloqueio de scroll
    menuDrawer.classList.remove('full-height'); // Remove classe fixa, se aplicada
    menuDrawer.style.visibility = 'hidden'; // Força a ocultação
  }
};

// Adicionar listener ao botão de fechar
document.querySelector('.menu-drawer__close-button')?.addEventListener('click', closeDrawer);

// Fechar ao clicar fora
document.addEventListener('click', (e) => {
  const drawer = document.getElementById('Details-menu-drawer-container');
  const menuDrawer = document.getElementById('menu-drawer');
  if (drawer && menuDrawer && !menuDrawer.contains(e.target) && !e.target.closest('.header__icon--menu')) {
    if (drawer.hasAttribute('open')) {
      closeDrawer();
    }
  }
});

// Garantir que aria-expanded seja atualizado ao abrir (caso não esteja no tema)
document.querySelector('.header__icon--menu')?.addEventListener('click', (e) => {
  const drawer = document.getElementById('Details-menu-drawer-container');
  if (drawer && !drawer.hasAttribute('open')) {
    e.currentTarget.setAttribute('aria-expanded', 'true');
    document.body.classList.add('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop'); // Adiciona bloqueio de scroll
  }
});

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = true;
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      // Toggle para submenus (usando <details> nativo)
      const detailsElements = this.querySelectorAll('.menu-drawer details');
      detailsElements.forEach((details) => {
        const summary = details.querySelector('summary');
        summary.addEventListener('click', (e) => {
          details.classList.toggle('open');
        });
      });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
